export default "__VITE_ASSET__Cag2GK0$__"